__turbopack_context__.v({
  "tag": "GVSm_q_tag",
  "tag--interactive": "GVSm_q_tag--interactive",
  "tag--is-rounded": "GVSm_q_tag--is-rounded",
  "tag--not-clickable": "GVSm_q_tag--not-clickable",
  "tag--small": "GVSm_q_tag--small",
  "tag--theme-active": "GVSm_q_tag--theme-active",
  "tag--theme-emphasis": "GVSm_q_tag--theme-emphasis",
  "tag--theme-light": "GVSm_q_tag--theme-light",
  "tag__icon-container": "GVSm_q_tag__icon-container",
  "tags": "GVSm_q_tags",
  "tags--center-content": "GVSm_q_tags--center-content",
  "tags__description": "GVSm_q_tags__description",
  "tags__error-message": "GVSm_q_tags__error-message",
  "tags__label": "GVSm_q_tags__label",
  "tags__list": "GVSm_q_tags__list",
});
